import React, { useEffect, useState } from "react";
import Home from "./Home";
import "../../../Header/home.css";
import Header from "../../../Header";
import AtendimentoVirtual from "../../../AtendimentoVirtual/AtendimentoVirtual";
import MessageLink from "../../../MessageLink";
import Footer from "../../../Footer";
import HomeBanner from "../../../Banner/Banner";
import Publicacoes from "../../../Publicacoes/Publicacoes";
import Noticias from "../../../Noticias/Noticias";
import Lgpd from "../../../Lgpd";
import ErrorBoundary from "../../../ErrorHandler/ErrorBoundary";
import GA4React from "ga-4-react";
import AtualizeSeusDados from "../../../AtualizeSeusDados/AtualizeSeusDados";
import CentralDeAtendimento from "../../../CentralDeAtendimento/CentralDeAtendimento";
import PrevCast from "../../../PrevCast/PrevCast";
import Conquistas from "../../../Conquistas/Conquistas";

const { REACT_APP_GOOGLE_GA_TAG } = process.env;

function App() {
  const [isloaded, setLoaded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 480);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    document.title = "Forluz - Institucional";

    if (!isloaded) {
      setLoaded(true);

      try {
        const ga4react = new GA4React(
          REACT_APP_GOOGLE_GA_TAG ?? "G-R0BM8HM4F8",
          {
            /* ga custom config, optional */
          },
          [
            /* additional code, optional */
          ],
          3000 /* timeout, optional, defaults is 5000 */
          /* { nonce: ['first-script-is-async','second-script'] } */
        );
        ga4react.initialize().then(
          (ga4) => {
            console.log("App", decodeURIComponent(document.title));

            let urlPathname = window.location.pathname + window.location.search;

            if (urlPathname === "/home" || urlPathname.startsWith("/home?")) {
              urlPathname = urlPathname.replace("/home", "/");
            }

            ga4.pageview(
              urlPathname,
              undefined,
              decodeURIComponent(document.title)
            );
          },
          (err) => {
            console.error(err);
          }
        );
      } catch (err) {
        console.error(err);
      }
    }
  }, [isloaded]);

  return (
    <div>
      <ErrorBoundary>
        <Header />
      </ErrorBoundary>

      {isMobile ? (
        <>
          <ErrorBoundary>
            <HomeBanner />
          </ErrorBoundary>

          <ErrorBoundary>
            <AtendimentoVirtual />
          </ErrorBoundary>
        </>
      ) : (
        <>
          <ErrorBoundary>
            <AtendimentoVirtual />
          </ErrorBoundary>

          <ErrorBoundary>
            <HomeBanner />
          </ErrorBoundary>
        </>
      )}

      <ErrorBoundary>
        <Noticias url="/ObterNoticiasHome"/>
      </ErrorBoundary>

      <ErrorBoundary>
        <Publicacoes />
      </ErrorBoundary>

      <ErrorBoundary>
        <AtualizeSeusDados />
      </ErrorBoundary>

      <ErrorBoundary>
        <CentralDeAtendimento />
      </ErrorBoundary>

      <ErrorBoundary>
        <PrevCast />
      </ErrorBoundary>

      <ErrorBoundary>
        <Conquistas />
      </ErrorBoundary>

      {/* <ErrorBoundary>
        <Home />
      </ErrorBoundary> */}

      <ErrorBoundary>
        <Footer />
      </ErrorBoundary>

      <ErrorBoundary>
        <MessageLink />
      </ErrorBoundary>

      <ErrorBoundary>
        <Lgpd />
      </ErrorBoundary>
    </div>
  );
}

export default App;
